<template>
  <q-page class="error-page">
    <div class="error-page__container">
      <!-- Left Panel - Content -->
      <div class="error-page__content">
        <img src="@/assets/flashy_logo_HD.svg" class="error-page__logo" alt="Flashy logo" />
        <h1 class="error-page__title">Oops!</h1>
        <h2 class="error-page__subtitle">We couldn't find that page.</h2>
        <p class="error-page__description">No stress, let's get you back on track. Try heading back to the home or login page to find what you need.</p>
        <q-btn flat class="error-page__button" no-caps @click="goToHome">
          <q-icon name="arrow_back" class="q-mr-sm" />
          Back to homepage
        </q-btn>
      </div>

      <!-- Right Panel - Image -->
      <div class="error-page__image-container">
        <img src="@/assets/DSC07355-min.jpg" alt="Error illustration" class="error-page__image" />
      </div>
    </div>
  </q-page>
</template>

<script>
export default {
  name: 'NotFound',
  methods: {
    goToHome() {
      this.$router.push({ name: 'home' });
    }
  }
};
</script>

<style lang="scss" scoped>
.error-page {
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  background-color: var(--main-bg-color);
  margin: 0;
  padding: 0;

  &__container {
    display: flex;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;

    @media (max-width: 991px) {
      flex-direction: column-reverse;
    }
  }

  &__content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 64px 0 94px;
    width: 70%;
    align-items: flex-start;
    text-align: left;

    @media (max-width: 1200px) {
      padding: 0 40px 0 60px;
    }

    @media (max-width: 991px) {
      width: 100%;
      height: 60vh;
      padding: 0 32px;
      align-items: center;
      text-align: center;
    }

    @media (max-width: 768px) {
      height: 65vh;
      padding: 0 24px;
    }

    @media (max-width: 480px) {
      height: 70vh;
      padding: 0 16px;
      justify-content: flex-start;
      padding-top: 60px;
    }
  }

  &__logo {
    height: 40px;
    margin-bottom: 64px;

    @media (max-width: 768px) {
      margin-bottom: 40px;
    }

    @media (max-width: 480px) {
      margin-bottom: 32px;
      height: 32px;
    }
  }

  &__title {
    @include inter-font($size: 48px, $bolded: true, $color: var(--main-text-color));
    margin: 0 0 8px 0;
    line-height: 1.2;

    @media (max-width: 768px) {
      font-size: 40px;
    }

    @media (max-width: 480px) {
      font-size: 32px;
    }
  }

  &__subtitle {
    width: 70%;
    @include inter-font($size: 48px, $bolded: true, $color: var(--main-text-color));
    margin: 0 0 24px 0;
    line-height: 1.2;

    @media (max-width: 768px) {
      font-size: 40px;
      margin: 0 0 20px 0;
    }

    @media (max-width: 480px) {
      font-size: 32px;
      margin: 0 0 16px 0;
    }
  }

  &__description {
    width: 70%;
    @include inter-font($size: 18px, $bolded: false, $color: var(--secondary-text-color));
    margin-bottom: 32px;
    line-height: 1.5;

    @media (max-width: 768px) {
      font-size: 16px;
      margin-bottom: 24px;
    }

    @media (max-width: 480px) {
      font-size: 14px;
      margin-bottom: 20px;
    }
  }

  &__button {
    @include inter-font($size: 18px, $bolded: true, $color: var(--main-text-color));
    background-color: var(--main-btn-color);
    padding: 12px 24px;
    border-radius: 8px;

    @media (max-width: 480px) {
      font-size: 14px;
      padding: 10px 20px;
    }
  }

  &__image-container {
    width: 50%;
    height: 100vh;
    overflow: hidden;
    margin: 0;
    padding: 0;

    @media (max-width: 991px) {
      width: 100%;
      height: 40vh;
    }

    @media (max-width: 768px) {
      height: 35vh;
    }

    @media (max-width: 480px) {
      height: 30vh;
    }
  }

  &__image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
</style>
